export default "__VITE_ASSET__A3Wy3jQk__"